export default {
    person: 1,
    commerce: 2,
    commerceSignsRequests: 3,
};
